// Vendors
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const ERROR_ACCORDION_COMPONENT_BUTTON_PROPS = {
  size: VARIANTS.ButtonSizeType.SMALL,
  type: VARIANTS.ButtonVariantType.PRIMARY_GHOST,
};

export { ERROR_ACCORDION_COMPONENT_BUTTON_PROPS };
